import AuditTrail from "@/pages/AuditTrail";

export default [
  {
    path: "audit-trail",
    name: "User Role Audit Trail",
    component: AuditTrail,
  },
];
